export const dashboard = {
  // Main navigation
  overview: 'Overview',
  vehicles: 'Vehicles',
  clients: 'Clients',
  bookings: 'Bookings',
  calendar: 'Calendar',
  contracts: 'Contracts',
  invoices: 'Invoices & Payments',
  reports: 'Reports',
  settings: 'Settings',
  agencySettings: 'Agency Settings',
  profileSettings: 'Profile Settings',
  agencyPanel: 'Agency Panel',
  agency: 'Agency',
  
  // Overview section
  welcome: 'Welcome',
  totalBookings: 'Total Bookings',
  activeRentals: 'Active Rentals',
  availableVehicles: 'Available Vehicles',
  totalClients: 'Total Clients',
  pendingPayments: 'Pending Payments',
  monthlyRevenue: 'Monthly Revenue',
  yearlyRevenue: 'Yearly Revenue',
  
  // Quick actions
  quickActions: 'Quick Actions',
  addNewVehicle: 'Add New Vehicle',
  createBooking: 'Create Booking',
  generateReport: 'Generate Report',
  
  // Notifications
  notifications: 'Notifications',
  upcomingPickups: 'Upcoming Pickups',
  upcomingReturns: 'Upcoming Returns',
  overdueReturns: 'Overdue Returns',
  noNotifications: 'No notifications',
  
  // Agency setup
  noAgency: 'No Agency Found',
  createAgencyFirst: 'You need to create an agency first to access the dashboard.',
  createAgency: 'Create Agency',
  
  // Empty states
  noCarsYet: 'No vehicles yet',
  noCarsYetDesc: 'You haven\'t added any vehicles to your fleet yet. Add your first vehicle to start managing your rental business.',
  addFirstVehicle: 'Add Your First Vehicle',
  addFirstVehicleMessage: 'Start by adding your first vehicle',
  welcomeToAgency: 'Welcome to Your Agency Dashboard!',
  
  // Setup steps
  step1: 'Step 1',
  step1Desc: 'Add your vehicles with photos and details',
  step2: 'Step 2', 
  step2Desc: 'Configure your rates and availability',
  step3: 'Step 3',
  step3Desc: 'Start receiving bookings',
  
  // Dashboard overview
  activityOverview: 'Overview of your activity and key indicators',
  newContract: 'New Contract',
  vehiclePlanning: 'Vehicle Planning',
  statisticsAnalytics: 'Statistics and Analytics',
  detailedAnalysis: 'Detailed analysis of your performance and key indicators',
  vehicleStatus: 'Vehicle Status',
  bookingStatus: 'Booking Status',
  categoryPerformance: 'Category Performance',
}; 